import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	createDTE as createDTEApi,
	readDTEFacele as readDTEFaceleApi,
	authenticate as loginDTEApi,
} from '../../helpers/warehouse/backend_helper';
import {
	createWarehouseGuide as createWarehouseGuideApi,
	getWarehouseGuides as getWarehouseGuidesApi,
	getWarehouseGuide as getWarehouseGuideApi,
	cancelWarehouseGuide as cancelWarehouseGuideApi,
} from '../../helpers/warehouseGuide/backend_helper';
import { gbusiness } from '../../config';

export const loginWarehouseDTE = createAsyncThunk(
	'warehouseGuide/loginWarehouseDTE',
	async () => {
		try {
			const response = await loginDTEApi({
				username: gbusiness.USER,
				password: gbusiness.PASS,
			});
			toast.success('Autenticación DTE exitosa.', { autoClose: 2000 });
			return response;
		} catch (error) {
			toast.error('Error de autenticación DTE.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const createDTE = createAsyncThunk(
	'warehouseGuide/createDTE',
	async ({ dte, service }) => {
		try {
			const response = await createDTEApi(dte, service);
			toast.success('DTE creado exitosamente.', { autoClose: 3000 });
			// Strip non-serializable headers from Axios response before storing in Redux
			if (response && response.headers) {
				const { headers, ...serializableResponse } = response;
				return serializableResponse;
			}
			return response;
		} catch (error) {
			toast.error('Error al crear DTE.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const readDTEFacele = createAsyncThunk(
	'warehouseGuide/readDTEFacele',
	async ({ file_type, dte_id }) => {
		try {
			const response = await readDTEFaceleApi({ file_type, dte_id });
			return response;
		} catch (error) {
			toast.error('Error al leer DTE Facele.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const createWarehouseGuide = createAsyncThunk(
	'warehouseGuide/create',
	async (guideData, { rejectWithValue }) => {
		try {
			const response = await createWarehouseGuideApi(guideData);
			return response;
		} catch (error) {
			toast.error('Error creando registro de guía warehouse');
			return rejectWithValue(error.response?.data || error.message);
		}
	}
);

export const getWarehouseGuides = createAsyncThunk(
	'warehouseGuide/getAll',
	async (params, { rejectWithValue }) => {
		try {
			const response = await getWarehouseGuidesApi(params);
			return response;
		} catch (error) {
			return rejectWithValue(error.response?.data || error.message);
		}
	}
);

export const getWarehouseGuide = createAsyncThunk(
	'warehouseGuide/getOne',
	async (guideId, { rejectWithValue }) => {
		try {
			const response = await getWarehouseGuideApi(guideId);
			return response;
		} catch (error) {
			return rejectWithValue(error.response?.data || error.message);
		}
	}
);

export const cancelWarehouseGuide = createAsyncThunk(
	'warehouseGuide/cancel',
	async ({ guideId, reason }, { rejectWithValue }) => {
		try {
			const response = await cancelWarehouseGuideApi(guideId, {
				guide_id: guideId,
				cancellation_reason: reason,
			});
			toast.success('Guía anulada exitosamente');
			return response;
		} catch (error) {
			const message = error.response?.data?.detail || error.message;
			toast.error(`Error anulando guía: ${message}`);
			return rejectWithValue(error.response?.data || error.message);
		}
	}
);
